import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const LatestNewBoxLeft = styled.div`
    border-right: 1px solid #d8d8d8;
    padding-right: 10px;

    @media screen and (max-width: 768px) {
        border-right: none;
        padding-right: 0;
    }

`


export const LatestNewsList = styled.ul`
    width: 100%;
    list-style: none;
`
export const LatestNewsImageLink = styled(Link)`
    display: block;
    text-decoration: none;
`

export const LatestNewsImage = styled.img`
    width: 100%;
`

export const LatestNewsBody = styled.div`
`

export const LatestNewsTitle = styled(Link)`
    text-decoration: none;
    color: #222;
    font-weight: bold;
    line-height: 18px;
    margin-bottom: 3px;
`

export const LatestNewsDesc = styled.p`
    color: #222;
    font-size: 12px;
    line-height: 14px;
    opacity: .7;
    margin-top: 5px;
`


export const LatestNewsItem = styled.li`
    display: flex;
    flex-direction: ${({type}) => type === 'big'?'column':'row'};
    padding: 10px 0 11px;
    border-bottom: dotted 1px #bdbdbd;

    & ${LatestNewsTitle} {
        font-size: ${({type}) => type === 'big'?'18px':'15px'};
        height: ${({type}) => type === 'big'?'36px':'unset'};
        -webkit-line-clamp: ${({type}) => type === 'big'?'2':'3'};
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: -webkit-box;
    }

    & ${LatestNewsImage} {
        height: ${({type}) => type === 'big'?'293px':'132px'};
    }

    & ${LatestNewsDesc} {
        -webkit-line-clamp: ${({type}) => type === 'big'?'2':'3'};
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: -webkit-box;
    }

    & ${LatestNewsBody} {
        order: ${({type}) => type === 'big'?'0':'1'};
        margin-left: ${({type}) => type === 'big'?'0':'10px'};
        margin-bottom: ${({type}) => type === 'big'?'15px':'0'};

    }

    & ${LatestNewsImageLink} {
        width: ${({type}) => type === 'big'?'100%':'212px'};
        order: ${({type}) => type === 'big'?'1':'0'};
    }

    & ${LatestNewsImage} {
        width: ${({type}) => type === 'big'?'100%':'212px'};
    }

    
 `
 export const LatestNewBoxRight = styled.div`
    padding-left: 10px;

    @media screen and (max-width: 767px) {
        padding: 0;
    }
`

export const CreatedDate = styled.span`
    color: #222;
    font-size: 12px;
    line-height: 14px;
    opacity: .7;
    margin-top: 8px;
    display: inline-block;
`

export const FlexCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    width: 100%;
`

export const LoadmoreButton = styled.button`
    outline: none;
`